import { useContext, useEffect, useState } from 'react';
import { TitleParamContext } from '../context/TitleContext';
import { LoginStateConext, UseLoginStateConext } from "../context/AuthContext";
import { HttpPostData, JumpPage } from "../common/Util";
import { ResponseParamBase } from "../common/Types";
import { Outlet, useNavigate } from 'react-router-dom';
/*import styled from "styled-components";*/
import base from "../css/base.module.css"
import market from "../css/market.module.scss"

//各画面のタイトル、ユーザの情報、ログアウトボタンの表示

type ResponseParam = ResponseParamBase & {

}

type ScreenTitleComponentParam = {
    title: string
}

export const ScrrenTitle = (props: ScreenTitleComponentParam) => {
    const customfook = useContext(TitleParamContext);
    const loginfook = UseLoginStateConext();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {

    }, []);

    return (

        <LoginStateConext.Consumer>
            {
                value => {
                    //if (value.isLogin) {
                        return (
                            <>
                                <div className={base.contentsTitle}>
                                    <div className={base.flexCenterColumn} style={{ width: "100%", height: "100%", justifyContent: value.isLogin ? "flex-end" : "center" }}>
                                        <div style={{ display: 'flex', alignItems: "baseline" }}>
                                            <h3 style={{ margin:"auto" }}>{customfook.param.mainTitle}</h3>
                                        </div>
                                        <div className={base.flexCenterRow} style={{ alignItems: "baseline" }}>
                                            <h2 style={{ marginTop: "5px" }}>{customfook.param.firstSubTitle}</h2>
                                            <h3>{customfook.param.secondSubTitle}</h3>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: "flex-end", justifyContent: 'flex-end', width: "100%", marginBottom: "10px", marginRight: "15px" }}>
                                        {
                                            value.isLogin ?
                                                <>
                                                    
                                                        <div className={market.systemUserName}>
                                                            {value.loginInfo.userName}
                                                        </div>
                                                        <button
                                                            className={market.loginButton}
                                                            disabled={isLoading}
                                                            onClick={(e) => {
                                                                HttpPostData<ResponseParam>('/authenticate/revoke/', { UserName: value.loginInfo.userName }, setIsLoading)
                                                                    .then(response => {
                                                                        if (response.status == 200) {
                                                                            loginfook.setIsLogin(false);
                                                                            loginfook.setLoginInfo({ email: "", userName: "" });
                                                                            window.localStorage.setItem("clickeracejwttoken", "");
                                                                            JumpPage("/Login", {}, "", navigate);
                                                                        }
                                                                    })
                                                                    .catch(e => {
                                                                        console.log(e)
                                                                    });
                                                            }}>ログアウト</button>
                                                    
                                                
                                                </> : <div></div>
                                        }
                                        </div>
                                    </div>
                                </div>
                                <Outlet />

                            </>
                        )
                    /*} else {
                        return (
                            <>
                                <div className={market.loginContentsTitle} style={{ justifyContent:"center" }}>
                                    <div className={base.flexCenterColumn} style={{ width: "100%" }}>
                                        <h3 style={{ margin: "auto" }}>{customfook.param.mainTitle}</h3>
                                        <div className={base.flexCenterRow}>
                                            <h2 style={{ marginTop: "10px" }}>{customfook.param.firstSubTitle}</h2>
                                            <h3>{customfook.param.secondSubTitle}</h3>
                                        </div>
                                    </div>                                    
                                </div>
                                <Outlet />
                            </>
                        );
                    }*/
                }
            }
            
        </LoginStateConext.Consumer>

    );
}